<span>{{text}}</span>

@if (isDone) {
	<mat-icon [inline]="true">check</mat-icon>
}
